import React, { Component } from "react";

class BrandTwo extends Component {
  render() {
    return (
      <React.Fragment>
        <ul className="brand-style-2">
          <li>
            <img src="/assets/images/brand/76-logo3.png" alt="Logo Images" />
          </li>
          {/* <li>
            <img
              src="/assets/images/brand/boost-mobile_logo.webp"
              alt="Logo Images"
            />
          </li> */}
          <li>
            <img src="/assets/images/brand/CALottery.webp" alt="Logo Images" />
          </li>
          <li>
            <img src="/assets/images/brand/redbull.png" alt="Logo Images" />
          </li>
          <li>
            <img src="/assets/images/brand/monster.png" alt="Logo Images" />
          </li>
          <li>
            <img src="/assets/images/brand/Coke.webp" alt="Logo Images" />
          </li>
          <li>
            <img src="/assets/images/brand/Pepsi.webp" alt="Logo Images" />
          </li>
          <li>
            <img src="/assets/images/brand/Frito-Lay.webp" alt="Logo Images" />
          </li>
          <li>
            <img src="/assets/images/brand/meg-logo.webp" alt="Logo Images" />
          </li>
        </ul>
      </React.Fragment>
    );
  }
}
export default BrandTwo;
